enum AreaTargetPermission {
  Prem_Area_Target_View = 'Prem_Area_Target_View',
  Prem_Area_Target_Create = 'Prem_Area_Target_Create',
  Prem_Area_Target_Edit = 'Prem_Area_Target_Edit',
  Prem_Area_Target_Delete = 'Prem_Area_Target_Delete',
  Prem_Area_Target_Approve = 'Prem_Area_Target_Approve',
  Prem_Area_Target_Manager_View = 'Prem_Area_Target_Manager_View',
}

export default AreaTargetPermission;
